<template>
  <div>
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">返回首页</router-link>
    </div>
    <!-- 返回 -->
    <div class="container">
      <h2 class="title1">"{{key}}" 搜索结果</h2>
      <div class="container-content">
        <!--正文内容-->
        <template v-for="item in stack">
        <p :key="item[0]"><router-link :to="{ path: item[0], query: { search: key } }">
            {{item[1]}}
        </router-link></p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import keywords from './keywords';
export default {
  data() {
    return {
      stack: [],
      key: ''
    };
  },
  mounted() {
    if (this.$route.query.search) {
      this.key = this.$route.query.search;
      this.stack = [];
      for (var i in keywords) {
        if (keywords[i]['content'].indexOf(this.key) != -1) {
          this.stack.push([i, keywords[i]['title']]);
        }
      }
    }

  }
};
</script>